import React, { useState } from 'react'
import { getRelativeServiceBasePath } from '../../../global/environments/path'
import LoaderIcon from './LoaderIcon.jsx'
import './index.css'

const Selector = ({ value, onChange }) => {
  const [loading, setLoading] = useState(false)

  const options = [
    { value: 'Select Role', label: 'Select Role' },
    { value: 'CIO/Analyst', label: 'CIO/Analyst' },
    { value: 'Principal/Founder', label: 'Principal/Founder' },
    { value: 'Wealth Advisor/Financial Planner', label: 'Wealth Advisor/Financial Planner' },
    { value: 'Compliance/Marketing', label: 'Compliance/Marketing' },
  ]

  const handleDropdownChange = (selectedValue) => {
    setLoading(true)
    onChange(selectedValue)

    // Ensure loader is visible for at least 1 second
    setTimeout(() => {
      setLoading(false)
    }, 900)
  }

  return (
    <div
      className="Selector u-flex u-flexAlignItemsCenter"
      style={{
        background: `url(${getRelativeServiceBasePath()}/webfiles/latest/assets/cti/images/selector/selector_bg.jpg) no-repeat`,
      }}
    >
      <div className="u-sizeConstrained u-flex u-flexAlignItemsCenter">
        <div className="u-md-size5of12 u-md-after3of12 u-lg-size5of12 u-lg-after3of12 selector-text">
          <p className="u-margin0 u-textColorWhite">
            Select your role. Watch your priorities come to life.
          </p>
        </div>
        <div className="u-md-size4of12 u-lg-size4of12 u-md-flex u-lg-flex u-flexAlignItemsCenter">
          <label
            htmlFor="role-selector"
            className="selector-label u-marginRight2gu u-textColorWhite u-textNoWrap u-hidden"
          >
            I am a:
          </label>
          <div className="Dropdown u-sizeFull u-flex u-flexAlignItemsCenter">
            <select
              id="role-selector"
              className="Dropdown-menu u-bgColorWhite"
              value={value}
              onChange={(e) => handleDropdownChange(e.target.value)}
              disabled={loading}
              data-analytics="cti-resources-ria-select-role-dropdown"
            >
              {options.map((opt) => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
            {loading && (
              <div className="Loader u-marginLeft1gu">
                {/* <LoaderIcon /> */}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Selector